"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Block", {
    enumerable: true,
    get: function() {
        return Block;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
var _core = require("@mantine/core");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n    width: 100px;\n    border-radius: 3px;\n    height: 0px;\n    background-color: 'white';\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal_loose([
        "\n    width: 100%;\n    border-radius: 3px;\n    margin-top: 2px;\n    height: 6px;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var Block = function(param) {
    var lines = param.lines, busy = param.busy, width = param.width;
    var Line = (0, _styled.default)("div")(_templateObject());
    var Block = (0, _styled.default)(_core.Flex)(_templateObject1(), function(props) {
        return busy ? "#857428" : "#cccccc";
    });
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Flex, {
        mih: 50,
        gap: "1%",
        justify: "flex-end",
        align: "flex-end",
        direction: "column",
        id: "block",
        style: {
            height: "50x",
            width: "" + width + "%"
        },
        children: lines > 0 && Array(lines).fill(true).map(function(_, i) {
            return /*#__PURE__*/ (0, _jsxruntime.jsx)(Block, {
                "data-testid": busy ? "busy" : ""
            }, i);
        })
    });
};
